/**
 * Login Page
 */

import { isAuthenticated, login } from '../lib/keycloak.js';

export async function renderLogin() {
  // Redirect to dashboard if already logged in
  if (isAuthenticated()) {
    window.location.href = '/dashboard';
    return;
  }

  // Redirect directly to Keycloak login
  login();
}

// Add styles
const style = document.createElement('style');
style.textContent = `
  .login-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, var(--color-midnight-black) 0%, var(--color-storm-grey) 100%);
    padding: var(--spacing-md);
  }
  
  .login-box {
    background: var(--color-storm-grey);
    border-radius: 12px;
    padding: var(--spacing-2xl);
    width: 100%;
    max-width: 400px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  }
  
  .login-header {
    text-align: center;
    margin-bottom: var(--spacing-xl);
  }
  
  .logo {
    font-family: var(--font-primary);
    font-size: 42px;
    font-weight: 800;
    margin-bottom: var(--spacing-xs);
    background: linear-gradient(135deg, var(--color-arctic-white) 0%, var(--color-ocean-blue) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .login-subtitle {
    color: var(--color-cloud-grey);
    font-size: 1rem;
  }
  
  .login-body {
    margin-top: var(--spacing-xl);
  }
`;

if (!document.getElementById('login-styles')) {
  style.id = 'login-styles';
  document.head.appendChild(style);
}
